import S9Detail from './S9Detail';

export default S9Detail;
